import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClientService } from '@flysas/httputil';
import { AuthService } from '@auth0/auth0-angular';
//import { Auth0Client } from '@auth0/auth0-spa-js';
declare const require: any;

@Injectable()
export class AppConfigService {
    private appConfig: any;
    
    constructor(private https: HttpClientService, private auth: AuthService ) { }

    loadAppConfig() {

        const host = window.location.host;
        if (host.indexOf('localhost') > -1) {
            this.appConfig = environment;
        } else {
            this.appConfig = require('./../../environments/environment.' + host.split('.')[0]);
            Object.keys(this.appConfig.environment).forEach(key => {
                environment[key] = this.appConfig.environment[key];
                
            });
        }
        this.https.apiBaseUrl = environment.apiBaseUrl;
        return new Promise((resolve, reject) => {
            this.auth.handleRedirectCallback();
            //const isAuthenticated = this.auth.user$
            this.auth.isAuthenticated$.subscribe(async authenticated => {
                //console.log('isAuthenticated: ',authenticated);
                if(authenticated) {
                    sessionStorage.setItem('isAuthenticated', JSON.stringify(authenticated));
                    //await this.getAccessToken();
                };
            resolve(true);
            })
        });
    }

    getConfig() {
        return this.appConfig;
    }
}
